import { render, staticRenderFns } from "./OptionalSelection.vue?vue&type=template&id=31eafa18&scoped=true"
import script from "./OptionalSelection.vue?vue&type=script&lang=js"
export * from "./OptionalSelection.vue?vue&type=script&lang=js"
import style0 from "./OptionalSelection.vue?vue&type=style&index=0&id=31eafa18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eafa18",
  null
  
)

export default component.exports